module.exports = __webpack_public_path__ + "img/rn-record-news.jpg";